import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import type { ESubscriptionModalAction } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.analytics';
import type { Product } from 'reactApp/types/Billing';
import type { DwhData } from 'reactApp/ui/Mobile/CancelAutoRenewalModal/CancelAutoRenewalModal.types';
import type { Reasons } from 'reactApp/ui/PollPopup/PollPopup.constants';

export interface OffersInfo {
    check?(args: CheckOffer): unknown;
    offer(args: OutflowOfferProps): unknown;
}
export interface CheckOffer {
    subscription: BillingDataSubscriptionInfo;
    product: Product;
}
export interface OutflowContext {
    choice?: Reasons;
}

export interface OutflowOfferProps extends CheckOffer {
    sendAnalytics?: (action: ESubscriptionModalAction, prefix?: string) => void;
    outflowContext: OutflowContext;
    continueOutflow(): void;
    cancelOutflow(): void;
}

export interface OutflowOfferWebProps extends OutflowOfferProps {}

export interface OutflowOfferMobileProps extends OutflowOfferProps {
    dwhData: DwhData;
    isRebrandingQuotaLanding?: boolean;
    isRebranding?: boolean;
}

export const enum OutflowOffers {
    ARE_YOU_SURE = 'ARE_YOU_SURE',
    VK_MUSIC = 'VK_MUSIC',
    UNLIMITED_AUTOUPLOAD = 'UNLIMITED_AUTOUPLOAD',
    FAMILY = 'FAMILY',
    PAUSE = 'PAUSE',
    DISCOUNT = 'DISCOUNT',
    /** TODO: Избавиться от CAPTCHA_WITH_SURVEY
     * Сейчас в капчу зашита отмена подписки и мы не можем показывать ее нигде, кроме как в последней позиции.
     * Нужно вынести логику отписки из капчи и вызывать ее в конце саги оттока.
     * Однако продуктовой необходимости в этом пока нет.
     * */
    CAPTCHA_WITH_SURVEY = 'CAPTCHA_WITH_SURVEY',
    /**
     * Однако, есть необходимость показывать опросник перед капчей, поэтому они существуют и в разделенном виде,
     * но с ограничением, что CAPTCHA будет в конце списка офферов.
     */
    CAPTCHA = 'CAPTCHA',
    SURVEY = 'SURVEY',
    // tempexp_19963:start
    // Показываем юзеру предупреждение, что он попадет в оверквоту
    OVERQUOTA_WARNING = 'OVERQUOTA_WARNING',
    OVERQUOTA_FILES = 'OVERQUOTA_FILES',
    // tempexp_19963:end
}
